import { defineStore } from 'pinia';
import { ref } from 'vue';
import { AccountingFileType } from '@/generated/graphql';

export const useCompanySubFolderPeriodFilesStore = defineStore('companySubFolderPeriodFilesStore', () => {
  const periodSubfoldersFiles = ref<AccountingFileType[]>();
  const currentOpenedFileId = ref<string | null>(null);

  const clearStore = () => {
    periodSubfoldersFiles.value = undefined;
    currentOpenedFileId.value = null;
  };

  const setCurrentOpenedFileId = (fileId: string) => {
    currentOpenedFileId.value = fileId;
  };

  return {
    periodSubfoldersFiles,
    currentOpenedFileId,
    clearStore,
    setCurrentOpenedFileId,
  };
});
